import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildAssetColumns } from './columns';
import { getAssetFields } from './fields';
import { getAssetSimpleFilters } from './simpleFilters';

/**
 * Repository QueryEntity - standalone entity reusing Asset filters
 */
export const repositoryEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'Repository', display: 'Repository' },
  buildColumns:
    buildAssetColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getAssetFields,
  getSimpleFilters: getAssetSimpleFilters,
};
